






import Vue from 'vue';

export default Vue.extend({
  name: "FunParkMain2d",
  data: () => {
    return {};
  },
});
